import { Form as AntForm, FormProps } from "antd";
import styled from "styled-components";

export const Form: typeof AntForm = styled(AntForm)<FormProps>``;
